 


<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">1.4、有哪些数据库</h1>
					 
					<h2 class="about-cs">1.4.1、有哪些常见的数据库？</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 早期最流行的关系型数据库是oralce、mysql、sqlServer等，其中性能最好是oracle、流行度最高的是mysql。
						最近这些年咱们中国也出现了一些国产数据库，比如达梦、金仓等。
						不同的数据库都有一些各自的特点，sql语句也稍有不同，好比中国人都说汉语，但是除了标准普通话外还有四川、东北、广东等地的方言，但是基本差别不大只要学会了一种在学其他的非常快。
						</div>
					<h2 class="about-cs">1.4.2、为什么选mysql讲解sql？</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp;本教程选用mysql8.0为基础环境给大家讲解sql的用法。</br>  
						&nbsp; &nbsp;&nbsp; &nbsp;1、MySQL是开放源代码，一般可以免费使用。</br>  
						&nbsp; &nbsp;&nbsp; &nbsp;2、应用范围广一般中小型网站的开发都选择MySQL 作为网站数据库。</br>  
						&nbsp; &nbsp;&nbsp; &nbsp;3、数据库安装相对简单，非常适合初学者。</br>  
						&nbsp; &nbsp;&nbsp; &nbsp; 注：sql语言不区分大小写，编写sql语句时只有单引号内的数据内容区分大小写，其他的部分大小写都可以正常执行。
					 </div>
					 
				</div>
			</div>
		</div>
	</div>
</template>


 <script>
 	 
 	export default {
 		components: {
 			 
 		},
 
 		data() {
 			return {
  
 			}
 		},
 
 		 
 		methods: {
 
 			showNote() {
 				 
 					this.$Message.info('介绍在线编辑器！');
 				 
 			}
 
 		},
 
 	}
 </script>

<style lang="scss"  scoped>
	#vip{
		color: red;
		
	}
	
	.about-xs {
		
		margin-bottom: 20px;
		margin-top: 10px;
		margin: 20px;
	}

	//标题字体
  .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
  .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 10px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}
 
	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
